import { useContext } from "react";
import { StepperContext, useLoanApplication } from "../../../contexts";
import ApplicantInformationForm from "./ApplicantInformationForm";
import { LoanApplicationStage } from "../../../hooks/api/types";

const OwnersInformationForm = () => {
  const { nextStep: onNextStep } = useContext(StepperContext);
  const {
    actions: { update },
  } = useLoanApplication();

  async function handleNextStep() {
    onNextStep();
    await update({
      stage: LoanApplicationStage.SHAREHOLDER_INFORMATION,
    });
  }

  return <ApplicantInformationForm onSubmit={handleNextStep} />;
};

export default OwnersInformationForm;
